import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DataService } from 'src/app/shared/network/data.service';
import { ColumnForSelection } from 'src/app/shared/import/column-for-selection';
import { BaseColumnSelectComponent } from '../base-column-selection.component';
import { ProjectService } from 'src/app/shared/project/project.service';
import { ImportProgressService } from 'src/app/shared/import/import-progress.service';
import { ImportStep } from 'src/app/shared/import/import-step';

@Component({
  templateUrl: './redundant-columns-selection.component.html',
  styleUrls: ['../../general.scss', '../column-selection.scss']
})
export class RedundantColumnsSelectComponent extends BaseColumnSelectComponent implements OnInit {
    projectId: string;
    columns: ColumnForSelection[];

    loading = true;

    constructor(private dataService: DataService, private activatedRoute: ActivatedRoute,
        private router: Router, private projectService: ProjectService, private importProgressService: ImportProgressService)
    {
        super();
    }

    public toggleSelect(column: ColumnForSelection): void {
        if (!column || !column.isEligible) {
            return;
        }
        column.isSelected = !column.isSelected;
    }

    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe((queryParams: any) => {
            let projectId = queryParams.projectId;
            if(projectId) {
                this.projectId = projectId;
                this.projectService.setProjectId(projectId);
                this.dataService.get<ColumnForSelection[]>('columnSelection/redundant/' + projectId)
                    .then(resp => {
                        if(!resp || !resp.length) {
                            this.router.navigateByUrl('/select-columns-dimensions?projectId=' + this.projectId);
                        }
                        this.columns = resp;
                        this.loading = false;
                    });
            }
        });
    }

    async save() {
        if (this.loading) {
            return;
        }
        try{
            this.loading = true;
            let selectedColumns = [];
            for(let i = 0; i < this.columns.length; ++i) {
                if(this.columns[i].isSelected) {
                    selectedColumns.push(i);
                }
            }
            await this.dataService.post('columnSelection/redundant', {
                projectId: this.projectId,
                selectedColumns: selectedColumns,
            });
            this.importProgressService.setImportStep(ImportStep.dimensions);
            this.router.navigateByUrl('/select-columns-dimensions?projectId=' + this.projectId);
        } finally {
            this.loading = false;
        }
    }
    
}
